import ApiService from '@core/api/services/ApiService';
import UrlResolver from '@core/url-resolver/UrlResolver';
import { RootState } from '@state/ducks';
import {
  ProductDetailAction,
  SET_INCLUDED_PRODUCTS,
  SET_INCLUDED_PRODUCTS_LOADING,
} from '@state/ducks/productdetail/productdetail.reducer';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export interface ProductWhatsIncludedRequest {
  modelAgilityId: number;
  variantAgilityId: number;
  cultureCode: string;
  published: boolean;
}

function fetchWhatsIncluded(
  modelAgilityId: number | null,
  variantAgilityId: number | null,
  cultureCode: string,
  published: boolean,
): Promise<IncludedProduct[]> {
  if (variantAgilityId === null) {
    return Promise.resolve([]);
  }
  if (modelAgilityId === null) {
    return Promise.resolve([]);
  }

  const params: ProductWhatsIncludedRequest = {
    modelAgilityId,
    variantAgilityId,
    cultureCode,
    published,
  };

  return ApiService.request<IncludedProduct[]>({
    method: 'GET',
    baseUrl: UrlResolver.getDomain(),
    controller: 'product-detail',
    slug: 'whats-included',
    params,
  });
}

export const useWhatsIncluded = (): boolean => {
  const modelAgilityId = useSelector<RootState, number | null>((state) => state.productDetail.modelAgilityId);
  const variantAgilityId = useSelector<RootState, number | null>(
    (state) => state.productDetail.selectedVariantAgilityId,
  );
  const pageContext = useSelector<RootState, PageContext>((state) => state.pageContext);
  const loadingIncludedProducts = useSelector<RootState, boolean>((x) => x.productDetail.loadingIncludedProducts);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch<ProductDetailAction>({ type: SET_INCLUDED_PRODUCTS_LOADING, payload: true });
    fetchWhatsIncluded(
      modelAgilityId,
      variantAgilityId,
      pageContext.documentCulture,
      pageContext.showOnlyPublishedProducts,
    ).then((products) => {
      dispatch<ProductDetailAction>({ type: SET_INCLUDED_PRODUCTS, payload: products });
    });
  }, [variantAgilityId]);

  return loadingIncludedProducts;
};
